module.exports = __webpack_public_path__ + "img/no-team-members.cdaa9682.webp";